import React, { useCallback, useRef, useState } from "react";
import "./searchBar.css";
import { IoMdClose } from "react-icons/io";
//import "./Autocomplete/autocompleteGo.css";

function SearchBar({ onChange, placeholder = "Buscar..." }) {
  const inputRef = useRef();
  const [showClearButton, setShowClearButton] = useState(false);

  const selectValue = useCallback(
    (item) => {
      inputRef.current.value = item == null ? "" : item.value;
      onChange && onChange(item);
    },
    [onChange]
  );

  function clearInput() {
    setShowClearButton(false);
    inputRef.current.value = "";
    inputRef.current.focus();

    selectValue(null);
  }

  return (
    <div className="search-bar">
      <div
        action="#"
        method="POST"
        className="search-form d-flex align-items-center"
      >
        <input
          ref={inputRef}
          type="text"
          name="query"
          placeholder={placeholder}
          title="Escribe palabra a buscar"
          onInput={(e) => {
            console.log("--> " + e.currentTarget.value);
            setShowClearButton(inputRef.current.value.length > 0);
          }}
          onKeyDown={(e) => {
            if (e.keyCode !== 13) {
              return;
            }

            if (onChange === null) {
              return;
            }

            onChange(inputRef.current.value);
            console.log("----Z " + inputRef.current.value);
            /*
            } else if (e.keyCode === 13) {
          /*If the ENTER key is pressed, prevent the form from being submitted,*
          e.preventDefault();
          if (currentFocus > -1) {
            and simulate a click on the "active" item:
            if (x) x[currentFocus].click();
            document.activeElement.blur();
            closeList();
          }
        }
        */
          }}
        />

        <button type="submit" title="Search">
          <i className="bi bi-search"></i>
        </button>
        <span
          onClick={(e) => {
            clearInput();
          }}
          className={`form-control-clear glyphicon glyphicon-remove form-control-feedback1 ${
            showClearButton ? "" : "hideButton"
          }`}
          style={{ margin: "-40px" }}
        >
          <IoMdClose />
        </span>
      </div>
    </div>
  );
}

export default SearchBar;
